module.exports = __webpack_public_path__ + "static/media/empresa.a03c3b94.svg";